import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center" data-testid="not-found">
      <div className="container-page text-center">
        <p className="eyebrow">404</p>
        <h1 className="mt-4 text-5xl md:text-7xl font-extrabold tracking-tighter text-slate-900 dark:text-white">Lost in the sitemap.</h1>
        <p className="mt-6 text-lg text-slate-600 dark:text-slate-300 max-w-xl mx-auto">
          That page has moved, been renamed, or never existed. Let's get you back to something useful.
        </p>
        <div className="mt-10 flex justify-center gap-3">
          <Link to="/" className="btn-primary">Go home <ArrowUpRight className="h-4 w-4" /></Link>
          <Link to="/contact" className="btn-secondary">Contact us</Link>
        </div>
      </div>
    </section>
  );
}
